<div class="segmented-control">
  <div
    class="segmented-container"
    [class.segmented-container--full-width]="fullWidth"
    [class.segmented-container--fit-content]="fitContent"
  >
    <div *ngIf="label">
      <span class="label">{{ label }}</span>
    </div>
    <div class="options" [class.options--fit-content]="fitContent" [class.options--sm]="size === 'sm'">
      <ng-container *ngFor="let option of options; let i = index">
        <div class="option-wrapper">
          <ng-container *ngTemplateOutlet="option.templateButton"></ng-container>
          <div *ngIf="i !== options.length - 1" class="divider"></div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="activeOption?.content" [@contentAnimation]="selectedIndex">
  <ng-container *ngTemplateOutlet="activeOption.content"></ng-container>
</div>
